import { gql } from '@apollo/client'

export const DISPOSITION_CORRECTION_FIELDS = gql`
  fragment DispositionCorrectionFields on DispositionCorrection {
    id
    percentChange
    correctionReason
    originalPrice
    correctedPrice
    sentAt
    createdAt
    fileUrl
    invoiceFileUrl
    invoiceNumber
    invoiceAttachedManually
    invoiceSentAt
  }
`

export const GET_DISPOSITIONS = gql`
  ${DISPOSITION_CORRECTION_FIELDS}
  query dispositions($agencyId: ID!, $first: Int, $last: Int) {
    dispositions(agencyId: $agencyId, first: $first, last: $last) {
      totalCount
      nodes {
        id
        campaignGqlId
        customerName
        customerAddress
        nip
        paidDate
        dueDate
        paymentMethod
        productName
        quantity
        price
        invoiceEmail
        invoiceNumber
        serviceId
        accountType
        accountValue
        signature
        createdAt
        sentAt
        fileUrl
        invoiceFileUrl
        invoiceAttachedManually
        invoiceSentAt
        corrections {
          ...DispositionCorrectionFields
        }
      }
    }
  }
`
